import * as React from 'react';
import type { SVGProps } from 'react';
const SvgImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M9.955 2h.09c1.474 0 2.642 0 3.571.101.953.104 1.743.322 2.421.82.389.286.732.629 1.017 1.018.498.678.716 1.468.82 2.42.102.93.102 2.098.102 3.572v.09c0 1.474 0 2.642-.102 3.57-.104.953-.322 1.744-.82 2.422a4.8 4.8 0 0 1-1.017 1.017c-.678.498-1.468.716-2.421.82-.929.102-2.097.102-3.571.102h-.09c-1.474 0-2.642 0-3.571-.102-.953-.104-1.743-.322-2.421-.82a4.8 4.8 0 0 1-1.017-1.017c-.498-.678-.716-1.469-.82-2.421-.102-.93-.102-2.097-.102-3.571v-.09c0-1.474 0-2.642.102-3.571.104-.953.322-1.743.82-2.421A4.8 4.8 0 0 1 3.963 2.92c.678-.498 1.468-.716 2.421-.82C7.313 2 8.481 2 9.955 2M6.547 3.593c-.824.09-1.318.26-1.696.537-.266.196-.501.43-.696.696-.278.379-.448.873-.538 1.697-.092.838-.093 1.924-.093 3.453s.001 2.615.093 3.453c.09.824.26 1.318.538 1.696.195.266.43.5.696.696.378.278.872.448 1.696.538.838.092 1.924.093 3.453.093 1.53 0 2.615-.001 3.453-.093.824-.09 1.318-.26 1.696-.538.266-.195.501-.43.696-.696.278-.378.448-.872.538-1.696.092-.838.093-1.924.093-3.453 0-1.53-.001-2.615-.093-3.453-.09-.824-.26-1.318-.538-1.697a3.3 3.3 0 0 0-.696-.696c-.378-.278-.872-.447-1.696-.537C12.615 3.5 11.53 3.5 10 3.5s-2.615.001-3.453.093"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.58 6.5a1.048 1.048 0 1 0 0 2.097 1.048 1.048 0 0 0 0-2.097m-2.048 1.048a2.048 2.048 0 1 1 4.097 0 2.048 2.048 0 0 1-4.097 0"
      clipRule="evenodd"
    />
    <path d="M7.586 12.145a.5.5 0 0 1 .742.027l3.692 4.42 1.117-.223-4.042-4.838a1.5 1.5 0 0 0-2.227-.083l-3.883 4 .821.205.551-.183z" />
    <path d="M13.8 12.625a1.5 1.5 0 0 0-2.16-.005l-1 1.033a.5.5 0 1 0 .72.695l.999-1.033a.5.5 0 0 1 .72.002l2.217 2.314 1.195-.2-2.69-2.806Z" />
  </svg>
);
export default SvgImage;
